import React, { useState } from 'react';
import { Box, Tabs, Tab, Card, CardContent, Typography, Breadcrumbs, Link } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import MainLayout from '../../components/layout/MainLayout';
import { ROLES } from '../../utils/constants';
import GlobalPstnPoolTab from '../../components/admin/voice/GlobalPstnPoolTab';
import TwimlResolverTab from '../../components/admin/voice/TwimlResolverTab';
import FeatureFlagsTab from '../../components/admin/voice/FeatureFlagsTab';
import VoiceTelemetryTab from '../../components/admin/voice/VoiceTelemetryTab';
import TwilioAccountTab from '../../components/admin/voice/TwilioAccountTab';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export default function VoiceSettingsPage() {
  const { userData, userClaims } = useAuth();
  const role = userClaims?.role || userData?.role;
  const [tab, setTab] = useState(0);

  if (role !== ROLES.ADMIN && role !== ROLES.SUPERADMIN) return null;

  return (
    <MainLayout>
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="#">Admin</Link>
          <Typography color="text.primary">Voice Settings</Typography>
        </Breadcrumbs>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>Voice & PSTN Settings</Typography>

      <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label="Voice settings tabs">
        <Tab label="Global PSTN Pool" />
        <Tab label="TwiML App & Resolver" />
        <Tab label="Feature Flags / Environment" />
        <Tab label="Telemetry / Logs" />
        <Tab label="Twilio Account Info" />
      </Tabs>

      <Card variant="outlined" sx={{ mt: 2 }}>
        <CardContent>
          <TabPanel value={tab} index={0}>
            <GlobalPstnPoolTab />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <TwimlResolverTab />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <FeatureFlagsTab />
          </TabPanel>
          <TabPanel value={tab} index={3}>
            <VoiceTelemetryTab />
          </TabPanel>
          <TabPanel value={tab} index={4}>
            <TwilioAccountTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
    </MainLayout>
  );
}
